import { render, staticRenderFns } from "./MasterDataIdle.vue?vue&type=template&id=53bf7056&scoped=true"
import script from "./MasterDataIdle.vue?vue&type=script&lang=js"
export * from "./MasterDataIdle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bf7056",
  null
  
)

export default component.exports